import { Injectable } from '@angular/core';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';


@Injectable({
  providedIn: 'root'
})
export class DownloadAsPdfService {

  constructor() { }

  incrementGraphPDFdownload(chartId: any, tableId: any, title: any, department: any): void {
    const chartElement: any = document.getElementById(chartId);
    const tableElement: any = document.getElementById(tableId);
    if (!chartElement && !tableElement) return;
    const scaleFactor = 1;
    html2canvas(chartElement, { scale: scaleFactor }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      const currentDate = new Date();
      const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;

      // Add Title
      pdf.setFontSize(16);
      pdf.text(title, 105, 10, { align: 'center' });

      // Add Department
      if (department !== null) {
        pdf.setFontSize(12);
        pdf.text(`Department: ${department}`, 10, 37, { maxWidth: 180 }); // Department on the left
      }

      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, 'PNG', 10, 45, imgWidth, imgHeight);
      pdf.save(`${title}-${todayDate}.pdf`);
    });

    html2canvas(tableElement, { scale: scaleFactor }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      const currentDate = new Date();
      const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;

      // Add Title
      pdf.setFontSize(16);
      pdf.text(title, 105, 10, { align: 'center' });

      // Add Department
      if (department !== null) {
        pdf.setFontSize(12);
        pdf.text(`Department: ${department}`, 10, 37, { maxWidth: 180 }); // Department on the left
      }

      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, 'PNG', 10, 45, imgWidth, imgHeight);
      pdf.save(`${title}-${todayDate}.pdf`);
    });
  }

  competencyGraphPDFdownload(chartId: any, tableId: any, title: any, year: any, score: any, CompetencyName: any, EmployeeName: any): void {
    const chartElement = document.getElementById(chartId);
    const tableElement = document.getElementById(tableId);
    if (!chartElement && !tableElement) return;

    const scaleFactor = 1;
    const generatePDF = async (element: HTMLElement, isChart: boolean) => {
      const canvas = await html2canvas(element, { scale: scaleFactor });
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      const currentDate = new Date();
      const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;

      let yOffset = 10;
      pdf.setFontSize(16);
      pdf.text(title, 105, yOffset, { align: 'center', maxWidth: 180 });
      yOffset += 10;

      pdf.setFontSize(12);
      if (year) {
        pdf.text(`Year: ${year}`, 10, yOffset, { maxWidth: 180 });
      }
      if (score) {
        yOffset += 10;
        pdf.text(`Score:`, 10, yOffset, { maxWidth: 50 });
        pdf.text(score, 25, yOffset, { maxWidth: 140 });
      }
      if (CompetencyName) {
        yOffset += 10;
        pdf.text(`Competency Name:`, 10, yOffset, { maxWidth: 50 });
        pdf.text(CompetencyName, 50, yOffset, { maxWidth: 140 });
      }
      if (EmployeeName) {
        yOffset += 10;
        pdf.text(`Employee Name:`, 10, yOffset, { maxWidth: 50 });
        pdf.text(EmployeeName, 44, yOffset, { maxWidth: 140 });
      }
      yOffset += 20;

      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, 'PNG', 10, yOffset, imgWidth, imgHeight);
      pdf.save(`${title}-${todayDate}.pdf`);
    };

    if (chartElement) {
      generatePDF(chartElement, true);
    }
    if (tableElement) {
      generatePDF(tableElement, false);
    }
  }

  taskManagementGraphPDFdownload(chartId: any, tableId: any, title: any, date: any, employeeName: any, task: any): void {
    const chartElement = document.getElementById(chartId);
    const tableElement = document.getElementById(tableId);
    if (!chartElement && !tableElement) return;

    const scaleFactor = 1;
    const generatePDF = async (element: HTMLElement, isChart: boolean) => {
      const canvas = await html2canvas(element, { scale: scaleFactor });
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      const currentDate = new Date();
      const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;

      let yOffset = 10;
      pdf.setFontSize(16);
      pdf.text(title, 105, yOffset, { align: 'center', maxWidth: 180 });
      yOffset += 10;

      pdf.setFontSize(12);
      if (date) {
        pdf.text(`Date:`, 10, yOffset, { maxWidth: 50 });
        pdf.text(date, 23, yOffset, { maxWidth: 140 });
      }
      if (employeeName) {
        yOffset += 10;
        pdf.text(`Employee Name:`, 10, yOffset, { maxWidth: 50 });
        pdf.text(employeeName, 46, yOffset, { maxWidth: 140 });
      }
      if (task) {
        yOffset += 10;
        pdf.text(`Task:`, 10, yOffset, { maxWidth: 50 });
        pdf.text(task, 30, yOffset, { maxWidth: 140 });
      }
      yOffset += 20;

      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, 'PNG', 10, yOffset, imgWidth, imgHeight);
      pdf.save(`${title}-${todayDate}.pdf`);
    };

    if (chartElement) {
      generatePDF(chartElement, true);
    }
    if (tableElement) {
      generatePDF(tableElement, false);
    }
  }

  PMSGraphPDFDownload(chartId: any, tableId: any, title: any, year: any, month: any, employeeName: any, Kpi: any, selectedUom: any): void {
    const chartElement = document.getElementById(chartId);
    const tableElement = document.getElementById(tableId);
    if (!chartElement && !tableElement) return;

    const scaleFactor = 1;
    const generatePDF = async (element: HTMLElement, isChart: boolean) => {
      const canvas = await html2canvas(element, { scale: scaleFactor });
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      const currentDate = new Date();
      const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;

      let yOffset = 10;
      pdf.setFontSize(16);
      pdf.text(title, 105, yOffset, { align: 'center', maxWidth: 180 });
      yOffset += 10;

      pdf.setFontSize(12);
      if (year) {
        pdf.text(`Year: ${year}`, 10, yOffset, { maxWidth: 180 });
      }
      if (month) {
        pdf.text(`Month: ${month}`, 50, yOffset, { maxWidth: 180 });
      }
      if (employeeName) {
        pdf.text(`Employee Name:`, 10, yOffset + 10, { maxWidth: 180 });
        pdf.text(employeeName, 45, yOffset + 10, { maxWidth: 180 });
      }
      yOffset += 20;

      if (Kpi) {
        pdf.text(`KPI:`, 10, yOffset);
        pdf.text(Kpi, 20, yOffset, { maxWidth: 180 });
      }
      if (selectedUom) {
        pdf.text(`Selected UOM:`, 10, yOffset + 10, { maxWidth: 180 });
        pdf.text(selectedUom, 40, yOffset + 10, { maxWidth: 180 });
      }
      yOffset += 20;

      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, 'PNG', 10, yOffset, imgWidth, imgHeight);
      pdf.save(`${title}-${todayDate}.pdf`);
    };

    if (chartElement) {
      generatePDF(chartElement, true);
    }
    if (tableElement) {
      generatePDF(tableElement, false);
    }
  }


  ESSGraphPDFDownload(chartId: any, tableId: any, title: any, year: any, servey: any, demographic: any): void {
    const chartElement: any = document.getElementById(chartId);
    const tableElement: any = document.getElementById(tableId);
    if (!chartElement && !tableElement) return;
    const scaleFactor = 1;
    html2canvas(chartElement, { scale: scaleFactor }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      const currentDate = new Date();
      const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;

      // Add Title
      pdf.setFontSize(16);
      pdf.text(title, 105, 10, { align: 'center' });

      // Add Year
      if (year !== null) {
        pdf.setFontSize(12);
        pdf.text(`Year: ${year}`, 10, 27);
      }

      // Add Servey
      if (servey !== null) {
        pdf.setFontSize(12);
        if (chartId == 'demographicTrendAnalysisGraph' || tableId == 'demographicTrendAnalysisTable') {
          pdf.text(`Servey: ${servey}`, 10, 35);
        } else {
          pdf.text(`Servey: ${servey}`, 50, 27);
        }
      }

      // Add Demographic
      if (demographic !== null) {
        pdf.setFontSize(12);
        if (chartId == 'demographicTrendAnalysisGraph' || tableId == 'demographicTrendAnalysisTable') {
          pdf.text(`Demographic: ${demographic}`, 10, 50);
        } else {
          pdf.text(`Demographic: ${demographic}`, 100, 27);
        }
      }
      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      if (chartId == 'demographicTrendAnalysisGraph' || tableId == 'demographicTrendAnalysisTable') {
        pdf.addImage(imgData, 'PNG', 10, 60, imgWidth, imgHeight);
      } else {
        pdf.addImage(imgData, 'PNG', 10, 35, imgWidth, imgHeight);
      }
      pdf.save(`${title}-${todayDate}.pdf`);
    });

    html2canvas(tableElement, { scale: scaleFactor }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      const currentDate = new Date();
      const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;

      // Add Title
      pdf.setFontSize(16);
      pdf.text(title, 105, 10, { align: 'center' });

      // Add Year
      if (year !== null) {
        pdf.setFontSize(12);
        pdf.text(`Year: ${year}`, 10, 27);
      }

      // Add Servey
      if (servey !== null) {
        pdf.setFontSize(12);
        if (chartId == 'demographicTrendAnalysisGraph' || tableId == 'demographicTrendAnalysisTable') {
          pdf.text(`Servey: ${servey}`, 10, 35);
        } else {
          pdf.text(`Servey: ${servey}`, 50, 27);
        }
      }

      // Add Demographic
      if (demographic !== null) {
        pdf.setFontSize(12);
        if (chartId == 'demographicTrendAnalysisGraph' || tableId == 'demographicTrendAnalysisTable') {
          pdf.text(`Demographic: ${demographic}`, 10, 50);
        } else {
          pdf.text(`Demographic: ${demographic}`, 100, 27);
        }
      }

      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      if (chartId == 'demographicTrendAnalysisGraph' || tableId == 'demographicTrendAnalysisTable') {
        pdf.addImage(imgData, 'PNG', 10, 60, imgWidth, imgHeight);
      } else {
        pdf.addImage(imgData, 'PNG', 10, 35, imgWidth, imgHeight);
      }
      pdf.save(`${title}-${todayDate}.pdf`);
    });
  }

  threeSixtyGraphPDFDownload(chartId: any, tableId: any, title: any, year: any, Review: any, Band: any, competencyName: any, Employee: any, Type: any): void {
    const chartElement: any = document.getElementById(chartId);
    const tableElement: any = document.getElementById(tableId);
    if (!chartElement && !tableElement) return;
    const scaleFactor = 1;
    html2canvas(chartElement, { scale: scaleFactor }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      const currentDate = new Date();
      const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;

      // Add Title
      pdf.setFontSize(16);
      pdf.text(title, 105, 10, { align: 'center' });

      // Add Year
      if (year !== null) {
        pdf.setFontSize(12);
        pdf.text(`Year: ${year}`, 10, 27);
      }

      // Add Review
      if (Review !== null) {
        pdf.setFontSize(12);
        pdf.text(`Review: ${Review}`, 10, 35);
      }

      //Add Band
      if (Band !== null) {
        pdf.setFontSize(12);
        pdf.text(`Band: ${Band}`, 10, 43);
      }

      // Add Competency Name
      if (competencyName !== null) {
        pdf.setFontSize(12);
        pdf.text(`Competency Name: ${competencyName}`, 10, 51);
      }

      // // Add Employee 
      if (Employee !== null) {
        pdf.setFontSize(12);
        if (Band == null || competencyName == null) {
          pdf.text(`Employee: ${Employee}`, 10, 51);
        } else {
          pdf.text(`Employee: ${Employee}`, 10, 43);
        }
      }

      // // Add Type
      if (Type !== null) {
        pdf.setFontSize(12);
        pdf.text(`Type: ${Type}`, 10, 59);
      }

      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, 'PNG', 10, 58, imgWidth, imgHeight);
      pdf.save(`${title}-${todayDate}.pdf`);
    });

    html2canvas(tableElement, { scale: scaleFactor }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      const currentDate = new Date();
      const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;

      // Add Title
      pdf.setFontSize(16);
      pdf.text(title, 105, 10, { align: 'center' });

      // Add Year
      if (year !== null) {
        pdf.setFontSize(12);
        pdf.text(`Year: ${year}`, 10, 27);
      }

      // Add Review
      if (Review !== null) {
        pdf.setFontSize(12);
        pdf.text(`Review: ${Review}`, 10, 35);
      }

      //Add Band
      if (Band !== null) {
        pdf.setFontSize(12);
        pdf.text(`Band: ${Band}`, 10, 43);
      }

      // Add Competency Name
      if (competencyName !== null) {
        pdf.setFontSize(12);
        pdf.text(`Competency Name: ${competencyName}`, 10, 51);
      }

      // // Add Employee 
      if (Employee !== null) {
        pdf.setFontSize(12);
        if (Band == null || competencyName == null) {
          pdf.text(`Employee: ${Employee}`, 10, 51);
        } else {
          pdf.text(`Employee: ${Employee}`, 10, 43);
        }
      }

      // // Add Type
      if (Type !== null) {
        pdf.setFontSize(12);
        pdf.text(`Type: ${Type}`, 10, 59);
      }

      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, 'PNG', 10, 58, imgWidth, imgHeight);
      pdf.save(`${title}-${todayDate}.pdf`);
    });
  }

  VPGraphPDFDownload(chartId: any, tableId: any, title: any, period: any, department: any): void {
    const chartElement: any = document.getElementById(chartId);
    const tableElement: any = document.getElementById(tableId);
    if (!chartElement && !tableElement) return;
    const scaleFactor = 1;
    html2canvas(chartElement, { scale: scaleFactor }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      const currentDate = new Date();
      const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;

      // Add Title
      pdf.setFontSize(16);
      pdf.text(title, 105, 10, { align: 'center' });

      // Add Period
      if (period !== null) {
        pdf.setFontSize(12);
        pdf.text(`Period: ${period}`, 10, 27);
      }

      // Add Department
      if (department !== null) {
        pdf.setFontSize(12);
        if (chartId == 'deptWiseVariablePayGraph' || tableId == 'deptWiseVariablePayTable' ||
          chartId == 'eligibleEmployeeCountGraph' || tableId == 'eligibleEmployeeCountTable'
        ) {
          pdf.text(`Department: ${department}`, 10, 37, {maxWidth: 180});
        } else if (chartId == 'actualAmountVariablePayGraph' || tableId == 'actualAmountVariablePayTable') {
          pdf.text(`Department: ${department}`, 10, 27, {maxWidth: 170});
        } else {
          pdf.text(`Department: ${department}`, 70, 27, {maxWidth: 170});
        }
      }

      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      if (chartId == 'deptWiseVariablePayGraph' || tableId == 'deptWiseVariablePayTable' ||
        chartId == 'eligibleEmployeeCountGraph' || tableId == 'eligibleEmployeeCountTable') {
        pdf.addImage(imgData, 'PNG', 10, 45, imgWidth, imgHeight);
      } else {
        pdf.addImage(imgData, 'PNG', 10, 35, imgWidth, imgHeight);
      }
      pdf.save(`${title}-${todayDate}.pdf`);
    });

    html2canvas(tableElement, { scale: scaleFactor }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      const currentDate = new Date();
      const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;

      // Add Title
      pdf.setFontSize(16);
      pdf.text(title, 105, 10, { align: 'center' });

      // Add Period
      if (period !== null) {
        pdf.setFontSize(12);
        pdf.text(`Period: ${period}`, 10, 27);
      }

      // Add Department
      if (department !== null) {
        pdf.setFontSize(12);
        if (chartId == 'deptWiseVariablePayGraph' || tableId == 'deptWiseVariablePayTable' ||
          chartId == 'eligibleEmployeeCountGraph' || tableId == 'eligibleEmployeeCountTable') {
          pdf.text(`Department: ${department}`, 10, 37, {maxWidth: 170});
        } else if (chartId == 'actualAmountVariablePayGraph' || tableId == 'actualAmountVariablePayTable') {
          pdf.text(`Department: ${department}`, 10, 27, {maxWidth: 170});
        } else {
          pdf.text(`Department: ${department}`, 70, 27, {maxWidth: 170});
        }
      }

      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      if (chartId == 'deptWiseVariablePayGraph' || tableId == 'deptWiseVariablePayTable' ||
        chartId == 'eligibleEmployeeCountGraph' || tableId == 'eligibleEmployeeCountTable') {
        pdf.addImage(imgData, 'PNG', 10, 45, imgWidth, imgHeight);
      } else {
        pdf.addImage(imgData, 'PNG', 10, 35, imgWidth, imgHeight);
      }
      pdf.save(`${title}-${todayDate}.pdf`);
    });
  }

  PDFDownload(id: any, title: any): void {
    const chartElement: any = document.getElementById(id);
    if (!chartElement) return;
    const scaleFactor = 1;
    html2canvas(chartElement, { scale: scaleFactor }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      const currentDate = new Date();
      const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;

      // Add Title
      pdf.setFontSize(16);
      pdf.text(title, 105, 10, { align: 'center' });

      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, 'PNG', 10, 20, imgWidth, imgHeight);
      pdf.save(`${title}-${todayDate}.pdf`);
    });
  }
}
